import classNames from 'clsx';
import React from "react";

interface InputLabelProps {
  label: string | React.ReactNode;
  name?: string;
  isFocused?: boolean;
  hasError?: boolean;
  className?: React.ComponentProps<"label">["className"];
}

export default function InputLabel({ label, name, isFocused, hasError, className }: InputLabelProps) {
  return (
    <label
      htmlFor={name}
      className={classNames(
        "text-sm font-semibold uppercase tracking-wide pb-1 transition-colors duration-200 ease-in-out",
        isFocused ? "text-bondi-blue-600" : "text-loblolly-900",
        hasError && "!text-carnation-500",
        className && className
      )}
    >
      {label}
    </label>
  );
}
